"use client";

import type { FC, Ref } from "react";
import { useTranslation } from "react-i18next";
import {
  PropertyValueAnalysis,
  type PropertyValueAnalysisProps,
} from "@huub-web/shared";
import { Button, Text, type UIAction, useActions } from "@huub-web/ui";

export interface AnalysisPropertyValueTemplateProps {
  currentPrice?: PropertyValueAnalysisProps["currentPrice"];
  squareMeterPrice?: PropertyValueAnalysisProps["squareMeterPrice"];
  wozPrices?: PropertyValueAnalysisProps["wozPrices"];
  description?: PropertyValueAnalysisProps["description"];
  CTAs?: {
    realisticOffer?: {
      label?: string;
      action: UIAction;
      tracking?: string;
    };
  };
}

/**
 * @deprecated
 */
export const AnalysisPropertyValueTemplate: FC<
  AnalysisPropertyValueTemplateProps & { ref?: Ref<HTMLDivElement> }
> = ({ currentPrice, squareMeterPrice, wozPrices, description, CTAs, ref }) => {
  const { t } = useTranslation();
  const { handleAction } = useActions();

  const handleRealisticOfferClick = () => {
    if (CTAs?.realisticOffer?.action) {
      handleAction(CTAs.realisticOffer.action);
    }
  };

  return (
    <PropertyValueAnalysis
      ref={ref}
      container="default"
      currentPrice={currentPrice}
      squareMeterPrice={squareMeterPrice}
      wozPrices={wozPrices}
      description={description}
      realisticOffer={
        <>
          <Text grow>
            {t("analysisPropertyValue.realisticOfferDescription")}
          </Text>
          {CTAs?.realisticOffer?.action && (
            <Button onClick={handleRealisticOfferClick} alignSelf="flex-start">
              {CTAs.realisticOffer.label ??
                t("analysisPropertyValue.discussWithAdvisor")}
            </Button>
          )}
        </>
      }
    />
  );
};
